import React from "react";
import {
  MaterialReactTable,
  useMaterialReactTable
} from "material-react-table";
import { Box, TextField, IconButton } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import ClearIcon from "@mui/icons-material/Clear";
import { spanishTableText } from "./tableTexts";
import icons from "../../constants/icons";

const TableComponent = ({
  columns,
  data,
  onRowClick,
  selectedRows,
  multiSelect = false,
  enableGlobalFilter = false,
  enableColumnOrdering = false,
  headerButtons = () => <></>
}) => {
  const safeSelectedRows = selectedRows || [];
  const getRowIdentifier = (row) => row?.id ?? row?.Id;
  const isRowSelected = (row) =>
    safeSelectedRows.some((sr) => getRowIdentifier(sr) === getRowIdentifier(row?.original));
  const table = useMaterialReactTable({
    columns,
    data,
    enableGlobalFilter,
    enableColumnOrdering,
    getRowId: (row) => row.id ?? row.Id ?? row.userId ?? row.featuresId,
    localization: spanishTableText,
    renderTopToolbarCustomActions: ({ table }) => headerButtons(table),
    muiTableBodyRowProps: ({ row }) => ({
      onClick: () => {
        onRowClick && onRowClick(row.original);
      },
      selected: multiSelect ? isRowSelected(row) : getRowIdentifier(safeSelectedRows[0]) === getRowIdentifier(row?.original),
      sx: {
        cursor: onRowClick ? "pointer" : "initial",
        backgroundColor: multiSelect ? (isRowSelected(row) ? "#e0f7fa" : "inherit") : (getRowIdentifier(safeSelectedRows[0]) === getRowIdentifier(row?.original) ? "#e0f7fa" : "inherit")
      }
    })
  });

  const renderGlobalFilter = () =>
    enableGlobalFilter && (
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <TextField
          placeholder="Buscar..."
          variant="outlined"
          size="small"
          value={table.getState().globalFilter || ""}
          onChange={(e) => table.setGlobalFilter(e.target.value)}
          InputProps={{
            startAdornment: <FilterListIcon sx={{ mr: 1 }} />
          }}
        />
        <IconButton onClick={() => table.setGlobalFilter("")} sx={{ ml: 1 }}>
          <img
            className="w-icon-25 icon-margin-r-15"
            src={icons.clearFilter}
            alt="icon"
          />
        </IconButton>
      </Box>
    );

  const renderTableToolbar = () => (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2
      }}
    >
      {renderGlobalFilter()}
      {/* {headerButtons} */}
    </Box>
  );

  return (
    <>
      {renderTableToolbar()}
      <MaterialReactTable table={table} />
    </>
  );
};

export default TableComponent;
